import React from "react";

const Header = () => {
  return (
    <header className="header">
      <div className="container">
        <ul>
          <li>
            <button>Кнопка</button>
          </li>

          <li>
            <button>Кнопка</button>
          </li>

          <li>
            <button>Кнопка</button>
          </li>
        </ul>
      </div>
    </header>
  );
};

export default Header;
